<template>
  <base-card overflowVisible :title="$t('mood')" hideNeuCardClass>
    <base-multi-select v-model="values" :placeholder="$t('searchOrSelectOptions')" label="name" searchable filtered :options="options" :disabled="historyReadOnly" />
    <div v-if="!historyReadOnly" class="mt-4">
      <base-button @click="save">{{$t('save-btn')}}</base-button>
    </div>
  </base-card>
</template>

<script>
import BaseMultiSelect from '@/components/base/forms/BaseMultiSelect'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import BaseCard from '@/components/base/ui/BaseCard.vue'
import BaseButton from '@/components/base/buttons/BaseButton'
import '@/plugins/vue-select'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'

export default {
    components: {
        BaseMultiSelect,
        BaseCard,
        BaseButton
    },
    props: {
      moodsVarsSelected: Array
    },
    created () {
      ClinicHistoryRepository().getMoods().then(item => {
        if (item.data.data) {
          let data = item.data.data
          this.options = data.moods
          this.values = data.moodsSelected
        }
      })
    },
    data () {
        return {
            values: [],
            options: []
        }
    },
    mixins: [clinicHistoryMixin],
    methods: {
      mapMoodsSelected (data) {
        return data.map(value => {
            let obj = this.options.find(item => item.value === value)
            if (obj) {
              return {name: obj.name, value: obj.value}
            }
            return []
          })
      },
      save () {
        let data = {values: this.values}
        ClinicHistoryRepository().saveMoods(data).then(data => {
          if (data.data) {
            this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          }
        })
      }
    }
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryMoodsSection.vue